import { performApplePayPayment, isApplePayJsAvailable } from './ApplePayJsHandler';
import { performApplePayPayment as performApplePayPaymentPaymentRequest, isPaymentRequestAvailable } from './PaymentRequestHandler';
import { paymentRequestApi } from './PaymentConf';

export { PaymentStatus } from './PaymentStatus';

export const isApplePayAvailable = () =>  {
    return paymentRequestApi ? isPaymentRequestAvailable() : isApplePayJsAvailable();
}

export const performPayment = (product, quantity, paymentMethodId, category) => {
    return paymentRequestApi ?
        performApplePayPaymentPaymentRequest(product, quantity, paymentMethodId, category) :
        performApplePayPayment(product, quantity, paymentMethodId, category);
}


// WEBPACK FOOTER //
// ./client/components/PaymentApi.js